import React, { Suspense, lazy } from 'react'
const StoreFeatureList = lazy(() => import('../containers/StoreFeatureList'))
import StoreApp from '../../Common/containers/StoreApp'
import { AppProvider } from '@!/providers'

const StoreFeatureListApp = (props) => {
  return (
    <AppProvider>
      <StoreApp {...props}>
        <Suspense fallback={null}>
          <StoreFeatureList items={props.items} currentTime={props.currentTime} />
        </Suspense>
      </StoreApp>
    </AppProvider>
  )
}

export default StoreFeatureListApp
